import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {language} from '../../../language/vn';
import {FormGroup} from '@angular/forms';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import { Subject} from 'rxjs';
@Component({
  templateUrl: './pdf.component.html'

})
export class PdfShowComponent implements OnInit {
  public language = language;
  public frmGroup: FormGroup;
  public id: number = 0;
  public isEdit: boolean = false;
  public isSuDung: boolean = true;
  private isMulti: boolean = false;
  public submitValidate = false;
  public onClose: Subject<boolean>;
  public pdfSrc: String;
  public pdfMulti: Object[] = [];

  constructor(public bsModalService: BsModalService,
              public _bsModalRef: BsModalRef,
  ) {

  }
  ngOnInit(): void {
    this.onClose = new Subject();


  }

  public show(url: String)
  {
    this.isMulti = false;
    this.pdfSrc= url;
  }
  public showMulti(files: Object[])
  {
    for (let i = 0; i < files.length; i++) {
      if ( files[i]["type"] === 'application/pdf' )
      {
        this.pdfSrc = files[i]["url"];
        break;
      }
    }
    this.isMulti = true;
    this.pdfMulti = files;
  }
  public onConfirm(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}
